import { __makeTemplateObject, __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { icons } from './icons.js';
import styled from 'styled-components';
var SVGIcon = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 1em;\n  height: 1em;\n"], ["\n  width: 1em;\n  height: 1em;\n"])));

var Icon = function Icon(_a) {
  var icon = _a.icon,
      className = _a.className,
      color = _a.color,
      rest = __rest(_a, ["icon", "className", "color"]);

  return /*#__PURE__*/React.createElement(SVGIcon, __assign({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: "2",
    clipRule: "evenodd",
    role: "img",
    viewBox: "0 0 48 48",
    className: (className ? className : '') + " " + icon
  }, rest), /*#__PURE__*/React.createElement("path", {
    fill: color || 'currentColor',
    d: icon && icons[icon]
  }));
};

var templateObject_1;
export { Icon };